import styled from "styled-components";

import NoviceImg from "./img/1st/novice.gif"
import SwordmanImg from "./img/1st/swordman.gif"
import ClericImg from "./img/1st/cleric.gif"
import MageImg from "./img/1st/mage.gif"
import ArcherImg  from "./img/1st/archer.gif"
import MerchantImg  from "./img/1st/merchant.gif"
import GatuneImg from "./img/1st/gatune.gif"

function FirstClassQuests() {
    return(
        <ClassListContainer>
            <ClassListItem>
                <ClassListIcon iconImage={NoviceImg}/>
                <ClassListDescription>Aprendiz</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={SwordmanImg}/>
                <ClassListDescription>Espadachim - Job Lv 10</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={ClericImg}/>
                <ClassListDescription>Noviço - Job Lv 10</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={MageImg}/>
                <ClassListDescription>Mago - Job Lv 10</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={ArcherImg}/>
                <ClassListDescription>Arqueiro - Job Lv 10</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={MerchantImg}/>
                <ClassListDescription>Mercador - Job Lv 10</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={GatuneImg}/>
                <ClassListDescription>Gatuno - Job Lv 10</ClassListDescription>
            </ClassListItem>
        </ClassListContainer>

    )
}

const TitleContainer = styled.h1`

`

const ClassListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    margin: 30px 0;
`

const ClassListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 250px;
    padding: 8px;
    margin: 2px 0;
    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

     &:hover {
        background-color: rgba(137, 151, 164, 1);
        color: white;
        scale: 1.2;
    }
`

const ClassListIcon = styled.div`
    background-image: url(${props => props.iconImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    //border: solid 1px rgba(0,0,0,1)
`

const ClassListDescription = styled.span`
    width: 200px;
    height: 25px;
`



export default FirstClassQuests